import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-view-rc-image',
  templateUrl: './view-rc-image.component.html',
  styleUrls: ['./view-rc-image.component.scss']
})
export class ViewRcImageComponent implements OnInit {

  public title !: string;
  public imagePath !: string;
  public onClose = new Subject<any>();


  constructor(public bsModalRef: BsModalRef,) { }

  ngOnInit(): void {
  }

  public onModalClose(): void {
    this.onClose.next('Success');
    this.bsModalRef.hide();
  }
}
